export const Hero = {
  Armor: [
    'ArcherTunic',        'BanditTunic',
    'BlueKnight',         'BlueWizardTunic',
    'CaptainArmor',       'Chief',
    'ChumDoctorTunic',    'ClericRobe',
    'DeathRobe',          'DeerCostume',
    'DemigodArmour',      'DruidRobe',
    'ElfTunic',           'Executioner',
    'FarmerClothes',      'FemaleOutfit',
    'FemaleSwimmingSuit', 'FireWizardRobe',
    'GuardianTunic',      'HeavyKnightArmor',
    'HolowKnight',        'HornsKnight',
    'IronKnight',         'LegionaryArmor',
    'MilitiamanArmor',    'MinerArmour',
    'MonkRobe',           'MusketeerTunic',
    'NecromancerRobe',    'NinjaTunic',
    'Overalls',           'PilotArmor',
    'PirateCostume',      'PirateRobe',
    'PumpkinOveralls',    'Samurai',
    'SantaHelperTunic',   'SantaTunic',
    'ThiefTunic',         'TravelerTunic'
  ],
  Arms: [
    'DarkElf',     'Demigod',
    'Demon',       'Elf',
    'FireLizard',  'Furry',
    'Goblin',      'Human',
    'HumanShadow', 'Lizard',
    'Merman',      'Orc',
    'Skeleton',    'Vampire',
    'Werewolf',    'ZombieA',
    'ZombieB'
  ],
  Back: [ 'BackSword', 'LargeBackpack', 'LeatherQuiver', 'SmallBackpack' ],
  Body: [
    'DarkElf',     'Demigod',
    'Demon',       'Elf',
    'FireLizard',  'Furry',
    'Goblin',      'Human',
    'HumanShadow', 'Lizard',
    'Merman',      'Orc',
    'Skeleton',    'Vampire',
    'Werewolf',    'ZombieA',
    'ZombieB'
  ],
  Bracers: [
    'ArcherTunic',      'BlueKnight',
    'BlueWizardTunic',  'CaptainArmor',
    'Chief',            'ChumDoctorTunic',
    'ClericRobe',       'DeathTunic',
    'DeerTunic',        'DemigodArmour',
    'DruidRobe',        'Executioner',
    'FireWizardRobe',   'GreenElfTunic',
    'GuardianTunic',    'HaloweenTunic',
    'HeavyKnightArmor', 'HolowKnight',
    'HornsKnight',      'IronKnight',
    'LegionaryArmor',   'MilitiamanArmor',
    'MonkRobe',         'MusketeerTunic',
    'NecromancerRobe',  'NinjaTunic',
    'PilotArmor',       'PirateRobe',
    'Samurai',          'SantaTunic',
    'ThiefTunic'
  ],
  Cape: [ 'Cape' ],
  Ears: [
    'DarkElf',     'Demigod',
    'Demon',       'Elf',
    'FireLizard',  'Furry',
    'Goblin',      'Human',
    'HumanShadow', 'Lizard',
    'Merman',      'Orc',
    'Skeleton',    'Vampire',
    'Werewolf',    'ZombieA',
    'ZombieB'
  ],
  Eyes: [
    'DarkElf',    'Demigod',
    'Demon',      'Elf',
    'FireLizard', 'Furry',
    'Goblin',     'Human',
    'Lizard',     'Merman',
    'Orc',        'Skeleton',
    'Vampire',    'Werewolf',
    'ZombieA',    'ZombieB'
  ],
  Firearm: [ 'AssaultRifle', 'Pistol', 'SniperRifle', 'Uzi' ],
  Hair: [
    'Hair1',  'Hair10',
    'Hair11', 'Hair12',
    'Hair13', 'Hair14',
    'Hair15', 'Hair2',
    'Hair3',  'Hair4',
    'Hair5',  'Hair6',
    'Hair7',  'Hair8',
    'Hair9'
  ],
  Head: [
    'DarkElf',     'Demigod',
    'Demon',       'Elf',
    'FireLizard',  'Furry',
    'Goblin',      'Human',
    'HumanShadow', 'Lizard',
    'Merman',      'Orc',
    'Skeleton',    'Vampire',
    'Werewolf',    'ZombieA',
    'ZombieB'
  ],
  Helmet: [
    'ArcherHood',
    'BanditBandana',
    'BanditPatch [ShowEars]',
    'BlueKnightHelmet',
    'BlueWizzardHat',
    'CaptainHelmet',
    'ChiefHat [ShowEars]',
    'ChumDoctorHelmet',
    'ClericHood',
    'DeathHood',
    'DeerHorns [ShowEars]',
    'DruidHelmet',
    'ExecutionerHood',
    'FireWizardHood',
    'GuardianHelmet',
    'HeavyKnightHelmet',
    'HolowKnightHelmet',
    'HornsHelmet',
    'HornsKnightHelmet',
    'IronKnightHelmet',
    'LegionaryHelmet',
    'MilitiamanHelmet',
    'MinerHelment',
    'MusketeerHat [ShowEars]',
    'NecromancerHood',
    'NinjaMask',
    'PilotHelment',
    'PirateBandana [ShowEars]',
    'PirateHelmet [ShowEars]',
    'PumpkinHead',
    'SamuraiHelmet',
    'SantaHelperCap [ShowEars]',
    'SantaHood',
    'SantaHoodBeard',
    'ThiefHood',
    'VikingHelmet'
  ],
  Horns: [ 'Demon' ],
  Mask: [
    'AnimeMask',
    'BanditMask',
    'BlackMask',
    'ChumMask',
    'DarkMask',
    'IronMask',
    'Shadow',
    'SuperMask'
  ],
  Shield: [
    'AncientGreatShield',
    'BlueShield',
    'BrassRoundShield',
    'CrusaderShield',
    'Dreadnought',
    'GoldenEagle',
    'GuardianShield',
    'IronBuckler',
    'KnightShield',
    'LegionShield',
    'RoyalGreatShield',
    'SteelShield',
    'TowerShield',
    'WoodenBuckler'
  ],
  Weapon: [
    'AmurWand',        'ArchStaff',        'AssaultSword',
    'Axe',             'BastardSword',     'BattleAxe',
    'BattleBow',       'BattleHammer',     'Bident',
    'BishopStaff',     'BlacksmithHammer', 'Blade',
    'BlueStick',       'BlueWand',         'Bow',
    'Branch',          'Broadsword',       'Butcher',
    'Crusher',         'CrystalWand',      'CurveBranch',
    'CurvedBow',       'Cutlass',          'Dagger',
    'DeathScythe',     'ElderStaff',       'Epee',
    'Executioner',     'FireWand',         'FlameStaff',
    'Fork',            'GiantBlade',       'GiantSword',
    'GoldenSkepter',   'GoldenSkullWand',  'Greataxe',
    'GreatHammer',     'Greatsword',       'GreenWand',
    'GuardianHalberd', 'Halberd',          'Hammer',
    'HermitStaff',     'HunterKnife',      'IronSword',
    'Katana',          'KitchenAxe',       'Knife',
    'Lance',           'LargePickaxe',     'LargeScythe',
    'LongBow',         'LongKatana',       'Longsword',
    'Mace',            'MagicWand',        'MarderDagger',
    'MasterGreataxe',  'MasterWand',       'Morgenstern',
    'NatureWand',      'NecromancerStaff', 'Pan',
    'Pickaxe',         'Pitchfork',        'PriestWand',
    'Rake',            'RedKatana',        'RedStick',
    'RedWand',         'RoundMace',        'RoyalLongsword',
    'RustedHammer',    'RustedPickaxe',    'RustedShortSword',
    'RustedShovel',    'Saber',            'Scythe',
    'Shestoper',       'ShitOnStick',      'ShortBow',
    'ShortDagger',     'Sickle',           'SkullWand',
    'SmallAxe',        'SmallPitchfork',   'SpikedClub',
    'Stick',           'StormStaff',       'Sword',
    'Tanto',           'WaterWand',        'WideDagger',
    'WoodcutterAxe'
  ]
}

export type ActionType = 'run' | 'idle' | 'slash' | 'die' | 'blink';
export type FiltersType = 'blink';

type BaseAction = {
  step: number;
  row: number;
  loop: boolean;
  filter?: FiltersType;
};

export type ActionsType = {
  [key in ActionType]: BaseAction;
};

type EffectsRender = {
  [key in FiltersType]: (frameIndex: number) => boolean;
}

export const EffectsRender: EffectsRender = {
  blink: (frameIndex: number) => {
    return frameIndex % 2 === 0;
  }
}

export const Actions: ActionsType = {
  run: {
    step: 4,
    row: 2, // first row is 0
    loop: true
  },
  idle: {
    step: 2,
    row: 0,
    loop: true
  },
  slash: {
    step: 4,
    row: 8,
    loop: false
  },
  blink: {
    step: 2,
    row: 0,
    loop: true,
    filter: 'blink',
  },
  die: {
    step: 3,
    row: 13,
    loop: false
  }
};

export const FrameSize = 64;
export const FrameOffsetY = FrameSize / 2;
export const HeroRegions = ['body', 'head', 'hair', 'eyes',  'arms', 'armor', 'helmet', 'weapon'];

export const EffectFrameCount = 30;
export const EffectCfg = {
  sprint: {
    col: 7,
    width: 120,
    height: 109
  },
  sneak: {
    col: 6,
    width: 291,
    height: 301,
  },
  magic: {
    col: 6,
    width: 265,
    height: 265
  }
}

export const MsgShowTime = 10;